// extracted by mini-css-extract-plugin
export default {"formWrapper":"style_formWrapper__9Yicd","title":"style_title__xY1co","forgotPassword":"style_forgotPassword__hKwl9","button":"style_button__nHo4g"};